module.exports = __webpack_public_path__ + "img/banner.d31cb3b1.png";